import styled from "styled-components";
import { theme } from "../../../config";

export const Main = styled.div`
  ${theme.mainContainerStyle}

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  @media ${theme.breakpoints.mobile} {
    overflow-x: hidden;
    ${theme.hideScrollbar}
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const Container = styled.div`
  width: 620px;
  height: 577px;
  margin-top: 20px;
  @media ${theme.breakpoints.mobile} {
    margin-top: 30px;
  }
`;

export const ImageWrapper = styled.div`
  text-align: center;
  margin-bottom: 50px;
  @media ${theme.breakpoints.mobile} {
    margin-bottom: 20px;
  }
`;

export const Logo = styled.img`
  width: 200px;
  @media ${theme.breakpoints.mobile} {
    width: 145px;
  }
`;

export const DataPrivacyDiv = styled.div`
  background: ${theme.colors.white};
  box-shadow: ${theme.defaultContainerBoxShadow};
  width: 620px;
  height: 480px;

  @media ${theme.breakpoints.mobile} {
    width: 100%;
    height: 100%;
  }
  @media ${theme.breakpoints.tablet} {
    width: 100%;
    height: 420px;
  }
`;

export const HeaderWrapper = styled.div`
  text-align: center;
  @media ${theme.breakpoints.mobile} {
    margin: 0 20px;
  }
`;

export const HeaderText = styled.h5`
  padding: 47px 0 20px 0;
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  font-family: Orkney Bold;

  @media ${theme.breakpoints.mobile} {
    font-size: 21.6px;
  }
`;

export const TextWrapper = styled.div`
  margin: 0 65px;
  font-size: 14px;
  line-height: 21px;

  @media ${theme.breakpoints.mobile} {
    margin: 0 34px;
  }
`;

export const ModalHyperlink = styled.span`
  cursor: pointer;
  color: ${theme.colors.activeAnchor};
`;

export const ButtonWrapper = styled.div`
  text-align: center;
  margin-top: 30px;
`;
